import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { take } from 'rxjs/operators';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';

@Component({
  selector: 'aims-grid-file-display',
  templateUrl: './aims-grid-file-display.component.html',
  styleUrls: ['./aims-grid-file-display.component.css']
})
export class AimsGridFileDisplayComponent implements OnInit {

  @Input() downloadUrl: string = null
  @Input() fileName: string

  constructor(private transferHttp: TransferHttpService, @Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
  }

    downloadFile(clickEvent) {
    if (isPlatformBrowser(this.platformId)) {
      clickEvent.stopPropagation()
      this.transferHttp
        .get(this.downloadUrl, { responseType: 'arraybuffer' })
        .pipe(take(1))
        .subscribe((response) => {
          let dataType = response.type
          let binaryData = []
          binaryData.push(response)
          let downloadLink = document.createElement('a')
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }))

          if (this.fileName) downloadLink.setAttribute('download', this.fileName)
          document.body.appendChild(downloadLink)
          downloadLink.click()
          downloadLink.parentNode.removeChild(downloadLink)
        })
    }
  }
}
